import { connect } from 'react-redux';
import { updateAPR } from '../../actions/updateCalculator';
import PercentInput from '../../components/inputs/PercentInput';

const mapStateToProps = (state, props) => {
	const calcData = Number(state.calculatorData.current.apr);

	return {
		value: calcData,
		placeholder: 'A.P.R. (estimated financing rate)',
		passedProps: { ...props }
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateValue: (newValue) => {
			dispatch(updateAPR(newValue));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(PercentInput);
